import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pagePreviews } from '../data/pagePreviews';
export function PagePreviews() {
  const trackRef = useRef<HTMLDivElement | null>(null);
  const [dragging, setDragging] = useState(false);
  const drag = useRef({
    startX: 0,
    startScroll: 0,
    moved: false
  });
  const scrollByCard = (dir: -1 | 1) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({
      left: dir * Math.round(el.clientWidth * 0.8),
      behavior: 'smooth'
    });
  };
  const onPointerDown = (e: React.PointerEvent<HTMLDivElement>) => {
    const el = trackRef.current;
    if (!el || e.pointerType === 'touch') return;
    drag.current = {
      startX: e.clientX,
      startScroll: el.scrollLeft,
      moved: false
    };
    setDragging(true);
    el.setPointerCapture(e.pointerId);
  };
  const onPointerMove = (e: React.PointerEvent<HTMLDivElement>) => {
    const el = trackRef.current;
    if (!el || !dragging) return;
    const dx = e.clientX - drag.current.startX;
    if (Math.abs(dx) > 3) drag.current.moved = true;
    el.scrollLeft = drag.current.startScroll - dx;
  };
  const endDrag = (e: React.PointerEvent<HTMLDivElement>) => {
    const el = trackRef.current;
    if (el && el.hasPointerCapture(e.pointerId)) el.releasePointerCapture(e.pointerId);
    setDragging(false);
  };
  return <section aria-label="Aperçu des pages intérieures" className="bg-transparent" data-id="element-118" data-mp="3it8srpewbpec">
      <div className="mx-auto max-w-6xl px-5 pb-12 pt-2" data-id="element-119" data-mp="3msr885ny789s">
        <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-120" data-mp="3rrawicq0kw5b">
          <h2 className="font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-121" data-mp="m2jmgqxzjq7">
            👀 Un aperçu de l'intérieur
          </h2>

          <div className="flex gap-2" data-id="element-122" data-mp="5jkuwdsfmb1d">
            <button type="button" onClick={() => scrollByCard(-1)} aria-label="Page précédente" className="flex h-10 w-10 items-center justify-center rounded-full border border-grape/25 bg-white text-plum transition-colors duration-150 ease-out hover:border-grape hover:text-grape focus:outline-none focus-visible:ring-2 focus-visible:ring-grape" data-id="element-123" data-mp="5ijgbzc7j6ew">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-124" data-mp="299h63c5qmnj5" />
            </button>
            <button type="button" onClick={() => scrollByCard(1)} aria-label="Page suivante" className="flex h-10 w-10 items-center justify-center rounded-full border border-grape/25 bg-white text-plum transition-colors duration-150 ease-out hover:border-grape hover:text-grape focus:outline-none focus-visible:ring-2 focus-visible:ring-grape" data-id="element-125" data-mp="297nwpp3qpp7g">
              <ChevronRightIcon className="h-5 w-5" data-id="element-126" data-mp="2n15fh7olqxwf" />
            </button>
          </div>
        </div>

        <div ref={trackRef} onPointerDown={onPointerDown} onPointerMove={onPointerMove} onPointerUp={endDrag} onPointerCancel={endDrag} className={`mt-6 flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${dragging ? 'cursor-grabbing select-none' : 'cursor-grab'}`} data-id="element-127" data-mp="310wqr0nqi06q">
          {pagePreviews.map((p, i) => <figure key={p.id} className="w-[68%] shrink-0 snap-center overflow-hidden rounded-2xl border border-grape/15 bg-white shadow-[0_18px_44px_-26px_rgba(67,32,26,0.55)] sm:w-[42%] lg:w-[30%]" data-id="element-128" data-mp="36p1lz6d6a68f" data-mpi={i}>
              <img src={p.src} alt={p.alt} loading={i === 0 ? 'eager' : 'lazy'} decoding="async" draggable={false} sizes="(min-width: 1024px) 30vw, (min-width: 640px) 42vw, 68vw" className="h-full w-full object-cover" data-id="element-129" data-mp="31odyuvs2e9jh" />
            </figure>)}
        </div>
      </div>
    </section>;
}